import request from '@/utils/request'

export function getTemporaryContract(query) {
  return request({
    url: '/cashier-service/v1/room-transaction/temporary-contract',
    method: 'post',
    params: query
  })
}
export function getProvisionalInvoice(query) {
  return request({
    url: '/cashier-service/v1/room-transaction/provisional-invoice',
    method: 'post',
    params: query
  })
}
export function getFolioDetail(query) {
  return request({
    url: '/cashier-service/v1/room-transaction/folio-detail',
    method: 'get',
    params: query
  })
}

/**
 *
 * @param {String} recode
 */
export function changeRoomTransToMasterApi(recode) {
  return request({
    url: `/cashier-service/v1/room-transaction/transfer/master/${recode}`,
    method: 'post'
  })
}
